<template>
    <div v-loading="loading">
        <div class="body">
            <navBox></navBox>
            <div class="banner" v-if="types == 'show'">
                <img :src="pic_fullpath" alt="" />
            </div>
            <div class="banner" v-if="types == 'link'">
                <router-link :to="{ path: pathUrl }">
                    <img :src="pic_fullpath" alt="" />
                </router-link>
            </div>
            <div class="wrap">
                <div class="English">
                    <!-- <span v-html="singleTitle"></span> -->
                    <!-- The vision of <span>MultiMetaverse</span> is to build a more
                    open and diversified world of virtual entertainment by
                    bringing together professional creators and users. -->
                    <label v-html="singlepage"></label>
                </div>
            </div>
            <div class="rel">
                <div class="middle-content">
                    <div class="wrap">
                        <div class="middle">
                            <!-- <span v-html="singleSecondTitle"></span> -->
                            <!-- <span>Multi Metaverse</span> aims to create a more
                            open ecosystem, provide more fundamental resources
                            and tools to PUGC authors, assist them in producing
                            professional and high-quality content in a more
                            decentralized manner, and provide players with a
                            more creative and diversified meta-universe
                            environment. -->
                             <label v-html="singlepageSecond"></label>
                        </div>
                    </div>
                </div>
                <div class="wrap hl">
                    <img
                        :src="singlepageThirdImg"
                        alt=""
                        class="person"
                    />
                    <div class="right-el">
                        <!-- <span class="symbol one">"</span> -->
                        <span class="content" v-html="singlepageThird">
                            <!-- The concept of a meta-universe is fascinating, but
                            when we think about it more deeply, we discover that
                            people demand more freedom and variety in their
                            virtual entertainment than they do in real life,
                            rather than living in the same virtual environment
                            with the same people and having the same
                            experiences. We believe that only by encouraging a
                            broad range of users to participate in content
                            creation will we be able to produce a diverse,
                            highly creative, and massive amount of new content
                            to meet the entertainment demands of our
                            users. -->
                        </span>
                        <!-- <span class="symbol">"</span>
                        <div class="name">Alex Xu,</div>
                        <div class="ceo">CEO, MultiMetaverse</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div id="certify">
            <div class="wrap swiper-con">
                <swiper ref="mySwiper" :options="swiperOptions" class="swiper"  v-if="goodVisibility">
                    <swiper-slide
                        v-for="(item, index) in bannerFoot"
                        :key="index"
                        :style="{
                            backgroundImage: 'url(' + item.pic_fullpath + ')',
                        }"
                    >
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import navBox from "@/components/navBox/navBox";
import footerBox from "@/components/footerBox/footerBox";
//let { mapActions, mapState } = createNamespacedHelpers("user"); //导入vuex user 模块
export default {
    name: "Home",
    components: { footerBox, navBox },
    data() {
        return {
            pic_fullpath: "",
            types: "show",
            pathUrl: "",
            singlepage: "",
            singleTitle:"",
            singlepageSecond: "",
            singleSecondTitle:"",
            singlepageThird: "",
            singlepageThirdImg:'',
            bannerFoot: [],
            loading:false
        };
    },
    computed: {
        //...mapState(["demo"]),
        swiperOptions() {
            return {
                watchSlidesProgress: true,
                slidesPerView: "auto",
                centeredSlides: true,
                loop: true,
                paginationClickable: true,
                clickable: true,
                autoplay: {
                    disableOnInteraction: false,
                },
                //轮播按钮支持点击
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                on: {
                    progress: function (progress) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i);
                            var slideProgress = this.slides[i].progress;
                            var modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify =
                                    (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            var translate = slideProgress * modify * 380 + "px";
                            var scale = 1 - Math.abs(slideProgress) / 3;
                            var zIndex =
                                999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform(
                                "translateX(" +
                                    translate +
                                    ") scale(" +
                                    scale +
                                    ")"
                            );
                            slide.css("zIndex", zIndex);
                            slide.css("opacity", 1);
                            if (Math.abs(slideProgress) > 3) {
                                slide.css("opacity", 0);
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                },
            };
        },
    },
    mounted() {},
    created() {
        this.goodVisibility = false   //在html里通过v-if='goodVisibility '来控制
        this.$nextTick(() => {
            this.goodVisibility = true
        })
        this.loading=true;
        this.$http.getWebIndex().then((res) => {
            //头部banner数据
            this.pic_fullpath =
                res.config["Banner-banner-head"][0].pic_fullpath;
            this.types = res.config["Banner-banner-head"][0].types;
            this.pathUrl = res.config["Banner-banner-head"][0].links;
            this.singleTitle=res.config["Single-singlepage-first"][0].title
            this.singlepage = res.config["Single-singlepage-first"][0].content;
            this.singleSecondTitle=res.config["Single-singlepage-second"][0].title;
            this.singlepageSecond =
                res.config["Single-singlepage-second"][0].content;
            this.singlepageThird =
                res.config["Single-singlepage-third"][0].content;
            this.singlepageThirdImg = res.config["Single-singlepage-third"][0].mainpic_fullpath;  
            this.bannerFoot = res.config["Banner-banner-foot"];
            this.loading=false;
        });
    },
};
</script>
<style lang="less" scoped>
.swiper-container {
    width: 500px;
    height: 300px;
    margin: 20px auto;
}
#certify {
    position: relative;
    width: 100%;
    height: 400px;
    margin: 0 auto;
    background: url("../../assets/homePage/bg.jpg");
}
#certify .swiper-container {
}
.shade {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    z-index: 1;
    background-color: #575757;
}
#certify .swiper-slide {
    width: 650px;
    height: 300px;
    background: #fff;
    /* box-shadow:0 8px 30px #ddd; */
    // margin-top: 50px;
    filter: brightness(0.7);
    padding-bottom: 0;
}
#certify .swiper-slide.swiper-slide-active {
    filter: brightness(1);
}
#certify .swiper-slide img {
    width: 650px;
    height: 300px;
    display: block;
}
#certify .swiper-pagination {
    width: 100%;
    bottom: 20px;
}
#certify .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 5px;
    border: 3px solid #fff;
    background-color: #d5d5d5;
    width: 10px;
    height: 10px;
    opacity: 1;
}
#certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
    border: 3px solid #00aadc;
    background-color: #fff;
}
/deep/.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
    display: none;
}
/deep/.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
    display: none;
}
#certify .swiper-button-prev {
    /* left:-30px; */
    width: 45px;
    height: 45px;
    background: url("../../assets/homePage/wm_button_icon.png") no-repeat;
    background-position: 0 0;
    background-size: 57%;
}
#certify .swiper-button-prev:hover {
    background-position: 0 -44px;
    background-size: 57%;
}
#certify .swiper-button-next {
    /* right:-30px; */
    width: 45px;
    height: 45px;
    background: url("../../assets/homePage/wm_button_icon.png") no-repeat;
    background-position: 0 -89px;
    background-size: 57%;
}
#certify .swiper-button-next:hover {
    background-position: 0 -134px;
    background-size: 57%;
}
/*===============================主体样式=========================================*/
.body {
    width: 100%;
}
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
}
/*英语内容*/
.English {
    font-size: 34px;
    color: #333333;
    width: 1080px;
    margin: 0 auto;
    text-align: center;
    padding: 105px 0;
    line-height:60px;
    font-family: 'Lucida Bright';
}
.English span {
    font-weight: bold;
    border-bottom: 3px solid #283254;
}
/*中间内容*/
.middle-content {
    background: url("../../assets/homePage/middle-bg.png");
    width: 100%;
    height: 475px;
}
.middle {
    padding-left: 450px;
    padding-top: 50px;
    font-size: 28px;
    color: #ffffff;
    line-height: 50px;
    font-family: 'Lucida Bright';
}
.middle span {
    font-size: 42px;
    font-weight: bold;
}
.rel {
    position: relative;
}
.person {
    position: absolute;
    top: 400px;
    margin-left: 100px;
}
.hl {
    height: 480px;
}
.right-el {
    width: 670px;
    float: right;
    padding: 90px 0px 10px 0px;
    line-height: 32px;
    font-family: 'Lucida Bright';
}
.right-el /deep/.symbol {
    color: #e5e5e5;
    font-size: 72px;
    display: inline-block;
    position: absolute;
    margin-top: 20px;
}
.content {
    color: #333333;
    font-size: 18px;
}
/deep/.one {
    margin-left: -30px;

}
/deep/.name {
    text-align: right;
    margin-right: 100px;
    font-weight: bold;
    color: #283254;
    margin-top: 25px;
    font-family: 'Microsoft PhagsPa';
}
/deep/.ceo {
    text-align: right;
    margin-right: 10px;
    font-size: 16px;
    font-family: 'Microsoft PhagsPa';
}
.swiper-con {
    position: relative;
    padding-top: 30px;
}

/deep/.swiper-container {
    width: 100%;
    .swiper-slide {
        width: 100%;
        height: 100%;
        padding-bottom: 28.1%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    .swiper-pagination {
        .swiper-pagination-bullet-active {
            background-color: #f29b76;
        }
    }
}
</style>
